import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { WatchStorageService } from '@parts-catalog/services/watchstorage.service';
import { AuthService } from '@reusable/services/auth/auth.service';
import * as globals from '@reusable/services/globals';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
declare let rudderanalytics: any;

@Injectable()
export class CartCustomerService {
  cart: CartInterface = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : null;

  private cartSource = new BehaviorSubject(null);
  currentCartStatus = this.cartSource.asObservable();

  constructor(
    private auth: AuthService,
    private httpClient: HttpClient,
    private gtn: globals.GetTokenNow,
    private watchStorage: WatchStorageService
  ) { }

  setupCart(newCart = false) {
    if (this.auth.isLoggedIn()) {
      this.doViewCart();
    }
    if (!this.cart || newCart) {
      this.createCart();
      return true;
    }
    return false;
  }

  createCart() {
    const cart = {
      addressId: '',
      quotaParts: [],
      premiumQuotations: [],
      usedParts: [],
      stockParts: []
    };

    localStorage.setItem('cart', JSON.stringify(cart));
    this.watchStorage.setItem('cartChange', true);
    this.cart = cart;
    this.cartSource.next(cart);
    return cart;
  }
  cartUpdatedAt() {
    this.cart.updatedAt = Date.now();
    this.watchStorage.setItem('cart', JSON.stringify(this.cart));
    this.watchStorage.setItem('cartChange', true);
  }

  viewCart() {
    return this.httpClient.get(`${globals.domain}/customer/carts/`, this.gtn.getHeaders()).pipe(map((res:any) => res as any));
  }

  updateCart(body) {
    return this.httpClient.put(`${globals.domain}/customer/carts/update/`, body, this.gtn.getHeaders()).pipe(map((res:any) => res as any));
  }

  getCheckoutAmountsService() {
    return this.httpClient.get(`${globals.domain}/customer/carts/get-checkout-amounts/`, this.gtn.getHeaders()).pipe(map((res:any) => res as any));
  }

  applyDiscountCode({ discountCode }) {
    return this.httpClient
      .post(`${globals.domain}/customer/carts/discount/`, { discountCode }, this.gtn.getHeaders())
      .pipe(map((res:any) => res as any));
  }

  getMatchingQuotationByName(name) {
    let matchingPart = null;
    try {
      matchingPart = this.cart.premiumQuotations.find((item) => item.name === name);
    } catch (e) { }
    return matchingPart;
  }

  addPremiumQuotationNotCatalog(premiumQuotation: PremiumQuotationInterface, ClassV2: string = 'N/A') {
    const pass = this.validationPQNotCatalog(premiumQuotation);
    if (!pass) {
      return false;
    }
    const matchingPart = this.getMatchingPartFromCart(premiumQuotation, this.cart.premiumQuotations, 'name');
    if (matchingPart) {
      matchingPart.selectedQuantity = matchingPart.selectedQuantity + 1;
    } else {
      if (this.cart?.premiumQuotations?.length) {
        this.cart.premiumQuotations.push(premiumQuotation);
      } else {
        this.cart.premiumQuotations = [];
        this.cart.premiumQuotations.push(premiumQuotation);
      }
    }
    rudderanalytics.track('Product Added', {
      product_id: premiumQuotation.carId,
      name: premiumQuotation.name,
      category: 'PremiumQuotation',
      quantity: 1,
      price: premiumQuotation.premiumPrice,
      currency: 'SAR'
    });
    if (this.auth.isLoggedIn()) {
      this.doUpdateCart(this.cart);
      return true;
    }
    localStorage.setItem('cart', JSON.stringify(this.cart));
    this.watchStorage.setItem('cartChange', true);
  }

  addQuotaPart(quotaPart: QuotaPartInterface, ClassV2: string = 'N/A') {
    const pass = this.validationQP(quotaPart);
    if (!pass) {
      return false;
    }
    const matchingPart = this.getMatchingPartFromCart(quotaPart, this.cart.stockParts, '_id');
    if (!matchingPart) {
      const pq: QuotaPartInterface = {
        _id: quotaPart._id,
        unitPrice: quotaPart.unitPrice,
        selectedQuantity: quotaPart.selectedQuantity
      };
      this.cart.quotaParts.push(pq);
    }
    rudderanalytics.track('Product Added', {
      product_id: quotaPart.catalogueNumber || quotaPart.name || quotaPart._id,
      name: quotaPart.name,
      category: 'QuotaParts',
      quantity: quotaPart.selectedQuantity,
      price: quotaPart.unitPrice,
      currency: 'SAR'
    });

    if (this.auth.isLoggedIn()) {
      this.doUpdateCart(this.cart);
      return true;
    }

    localStorage.setItem('cart', JSON.stringify(this.cart));
    this.watchStorage.setItem('cartChange', true);
    return true;
  }

  removeQuotaParts(index) {
    const quotaParts = this.cart.quotaParts[index];
    this.cart.quotaParts.splice(index, 1);
    if (!quotaParts) {
      return;
    }
    try {
      rudderanalytics.track('Product Removed', {
        product_id: quotaParts.catalogueNumber || quotaParts.name || quotaParts._id,
        name: quotaParts.name,
        category: 'QuotaParts',
        price: quotaParts.price,
        quantity: quotaParts.selectedQuantity
      });
    } catch (err) { }
    if (this.auth.isLoggedIn()) {
      this.doUpdateCart(this.cart);
      return;
    }
    localStorage.setItem('cart', JSON.stringify(this.cart));
    this.watchStorage.setItem('cartChange', true);
    return;
  }


  doUpdateCart(cart: CartInterface, disableToastr?: Boolean) {
    const body: CartInterface = {
      addressId: cart.addressId,
      quotaParts: cart.quotaParts,
      premiumQuotations: cart.premiumQuotations,
      usedParts: cart.usedParts,
      stockParts: cart.stockParts
    };
    body.stockParts = cart.stockParts.map((item) => {
      const stockPart: StockPartInterface = {
        _id: item._id,
        name: item.name,
        selectedQuantity: item.selectedQuantity || 1,
        internalModelId: item.internalModelId,
        modelYear: item.modelYear,
        externalCarId: item.externalCarId,
        externalcatalogueId: item.externalcatalogueId,
        vinNumber: item.vinNumber,
        vinManuallyEntered: item.vinManuallyEntered || false,
        addedFromPage: item.addedFromPage
      };
      return stockPart;
    });
    body.premiumQuotations = cart.premiumQuotations.map((item) => {
      const addInfo: AdditionalInfoInterface = {
        engineSize: item?.additionalCarInformation?.engineSize,
        grade: item?.additionalCarInformation?.grade,
        salesRegion: item?.additionalCarInformation?.salesRegion,
        transmissionType: item?.additionalCarInformation?.transmissionType,
        fuelType: item?.additionalCarInformation?.fuelType
      };
      const premiumQuotation: PremiumQuotationInterface = {
        carId: item.carId,
        name: item.name,
        internalModelId: item.internalModelId,
        modelYear: item.modelYear,
        otherinformation: item.otherinformation,
        partType: item.partType,
        catalogueNumber: item.catalogueNumber,
        corePartId: item.corePartId,
        selectedQuantity: item.selectedQuantity || 1,
        vinNumber: item.vinNumber,
        addedFromPage: item.addedFromPage,
        photo: item.photo,
        additionalCarInformation: addInfo
      };
      if (!premiumQuotation.carId) {
        delete premiumQuotation.carId;
      }
      return premiumQuotation;
    });
    body.quotaParts = cart.quotaParts.map((item) => {
      const quotaParts: QuotaPartInterface = {
        _id: item._id,
        selectedQuantity: item.selectedQuantity || 1
      };
      return quotaParts;
    });
    if (!body.addressId) {
      delete body.addressId;
    }
    // const notValidstockParts = cart.stockParts.find((part) => !part.modelYear || !part.name);
    const notValidpremiumQuotations = cart.premiumQuotations.find((part) => !part.modelYear || !part.name);
    // if (notValidstockParts || notValidpremiumQuotations) {
    if (notValidpremiumQuotations) {
      return;
    }

    this.viewCart().subscribe((viewCartResponse) => {
      if (viewCartResponse.case === 1) {
        const localDB = cart.updatedAt || Date.now();
        const serverDB = new Date(viewCartResponse.cart.updatedAt).valueOf();
        if (localDB > serverDB) {
          // local cart newer than server cart
          // so push local cart
          this.updateCart(body).subscribe(
            (updateRes) => {
              if (updateRes) {
                this.viewCart().subscribe((res:any) => {
                  if (res.case === 1) {
                    this.doMapCart(res.cart);
                    if (!disableToastr) {
                    }
                  }
                });
              } else {
                this.viewCart().subscribe((res:any) => {
                  this.doMapCart(res.cart);
                  if (!disableToastr) {
                  }
                });
              }
            },
            (err) => {
              this.viewCart().subscribe((res:any) => {
                this.doMapCart(res.cart);
              });
            }
          );
        } else {
          // server cart newer than local cart
          // that means that its updated from another platform
          // so get server cart instead of local card
          this.mapDBCart(viewCartResponse.cart);
        }
      }
    });

  }

  mapDBCart(updatedCart) {
    if (!this.cart) {
      this.setupCart();
    }
    this.cart.deliveryFees = updatedCart.deliveryFees && parseFloat(updatedCart.deliveryFees || 0).toFixed(2);
    this.cart.discountAmount = parseFloat(updatedCart.discountAmount || 0).toFixed(2);
    this.cart.isDiscountCodeExpired = updatedCart.isDiscountCodeExpired;
    this.cart.isDiscountedDeliveryFees = updatedCart.isDiscountedDeliveryFees;
    this.cart.paidQuotationsAmount = parseFloat(updatedCart.paidQuotationsAmount || 0).toFixed(2);
    this.cart.stockPartsAmount = parseFloat(updatedCart.stockPartsAmount || 0).toFixed(2);
    this.cart.vatAmount = parseFloat(updatedCart.vatAmount || 0).toFixed(2);
    this.cart.totalAmount = parseFloat(updatedCart.totalAmount || 0).toFixed(2);
    this.cart.totalAmountBeforeDiscount = parseFloat(updatedCart.totalAmountBeforeDiscount || 0).toFixed(2);
    this.cart.stockParts = [];
    if (updatedCart.stockParts?.length) {
      updatedCart.stockParts.forEach((item) => {
        this.cart.stockParts.push({
          _id: item._id._id ? item._id._id : item._id,
          name: item._id.cataloguePartId ? item._id.cataloguePartId.name : item.name,
          vinNumber: item.vinNumber,
          catalogueNumber: item._id.cataloguePartId ? item._id.cataloguePartId.catalogueNumber : item.catalogueNumber,
          unitPrice: item.unitPrice,
          selectedQuantity: item.selectedQuantity,
          internalModelId: item.internalModelId._id || item.internalModelId,
          modelYear: item.modelYear,
          externalCarId: item.manufactureId,
          externalcatalogueId: item.externalcatalogueId,
          isPriceChanged: item.isPriceChanged,
          isQuantityChanged: item.isQuantityChanged,
          availableQuantity: item._id.availableQuantity ? item._id.availableQuantity : item.selectedQuantity,
          branchName: item._id.branchId ? item._id.branchId.publicName : item.branchName,
          isDomestic: item._id.branchId ? item._id.branchId.isDomestic : item.isDomestic,
          make: item._id.make ? item._id.make : item.make,
          addedFromPage: item.addedFromPage
        });
      });
    }
    this.cart.premiumQuotations = [];
    if (updatedCart.premiumQuotations?.length) {
      updatedCart.premiumQuotations.forEach((item) => {
        const addInfo: AdditionalInfoInterface = {
          engineSize: item?.additionalCarInformation?.engineSize,
          grade: item?.additionalCarInformation?.grade,
          salesRegion: item?.additionalCarInformation?.salesRegion,
          transmissionType: item?.additionalCarInformation?.transmissionType,
          fuelType: item?.additionalCarInformation?.fuelType
        };
        this.cart.premiumQuotations.push({
          carId: item.carId,
          internalModelId: item.internalModelId._id || item.internalModelId,
          modelYear: item.modelYear,
          otherinformation: item.otherinformation,
          name: item.name,
          partType: item.partType,
          catalogueNumber: item.catalogueNumber,
          corePartId: item.corePartId,
          premiumPrice: item.premiumPrice,
          vinNumber: item.vinNumber,
          selectedQuantity: 1,
          addedFromPage: item.addedFromPage,
          photo: item.photo,
          additionalCarInformation: addInfo
        } as PremiumQuotationInterface);
      });
    }
    this.cart.quotaParts = [];
    if (updatedCart.quotaParts?.length) {
      updatedCart.quotaParts.forEach((item) => {
        this.cart.quotaParts.push({
          _id: item._id,
          unitPrice: item.unitPrice,
          selectedQuantity: item.selectedQuantity
        });
      });
    }
    this.watchStorage.setItem('cart', JSON.stringify(this.cart));
    this.watchStorage.setItem('cartChange', true);
  }


  doMapCart(updatedCart) {
    if (!this.cart) {
      this.setupCart();
    }
    let hasNew = false;
    if (updatedCart) {
      this.cart.deliveryFees = updatedCart.deliveryFees && parseFloat(updatedCart.deliveryFees || 0).toFixed(2);
      this.cart.discountAmount = parseFloat(updatedCart.discountAmount || 0).toFixed(2);
      this.cart.isDiscountCodeExpired = updatedCart.isDiscountCodeExpired;
      this.cart.isDiscountedDeliveryFees = updatedCart.isDiscountedDeliveryFees;
      this.cart.paidQuotationsAmount = parseFloat(updatedCart.paidQuotationsAmount || 0).toFixed(2);
      this.cart.stockPartsAmount = parseFloat(updatedCart.stockPartsAmount || 0).toFixed(2);
      this.cart.vatAmount = parseFloat(updatedCart.vatAmount || 0).toFixed(2);
      this.cart.totalAmount = parseFloat(updatedCart.totalAmount || 0).toFixed(2);
      this.cart.totalAmountBeforeDiscount = parseFloat(updatedCart.totalAmountBeforeDiscount || 0).toFixed(2);
    }
    updatedCart.stockParts.forEach((item) => {
      const existingPart = this.cart.stockParts.find((part) => part._id === (item._id._id ? item._id._id : item._id));
      if (existingPart) {
        if (typeof item._id === 'object') {
          existingPart.name = item._id.cataloguePartId.name;
          existingPart.catalogueNumber = item._id.cataloguePartId.catalogueNumber;
          existingPart.isDomestic = item._id.branchId.isDomestic;
          existingPart.unitPrice = item.unitPrice;
          existingPart.selectedQuantity = item.selectedQuantity;
        } else if (typeof item._id === 'string') {
          existingPart.name = item.name;
          existingPart.catalogueNumber = item.catalogueNumber;
          existingPart.branchName = item.branchName;
          existingPart.isDomestic = item.isDomestic;
          existingPart.unitPrice = item.unitPrice;
          existingPart.selectedQuantity = item.selectedQuantity;
        }
      } else {
        this.cart.stockParts.push({
          _id: item._id._id ? item._id._id : item._id,
          name: item._id.cataloguePartId ? item._id.cataloguePartId.name : item.name,
          vinNumber: item.vinNumber,
          catalogueNumber: item._id.cataloguePartId ? item._id.cataloguePartId.catalogueNumber : item.catalogueNumber,
          unitPrice: item.unitPrice,
          selectedQuantity: item.selectedQuantity,
          internalModelId: item.internalModelId._id || item.internalModelId,
          modelYear: item.modelYear,
          externalCarId: item.manufactureId,
          externalcatalogueId: item.externalcatalogueId,
          isPriceChanged: item.isPriceChanged,
          isQuantityChanged: item.isQuantityChanged,
          availableQuantity: item._id.availableQuantity ? item._id.availableQuantity : item.selectedQuantity,
          branchName: item._id.branchId ? item._id.branchId.publicName : item.branchName,
          isDomestic: item._id.branchId ? item._id.branchId.isDomestic : item.isDomestic,
          make: item._id.make ? item._id.make : item.make,
          addedFromPage: item.addedFromPage
        });
        hasNew = true;
      }
    });
    if (updatedCart.premiumQuotations?.length) {
      updatedCart.premiumQuotations.forEach((item) => {
        const existingPart = this.cart.premiumQuotations.find((part) => part.catalogueNumber === item.catalogueNumber);
        if (existingPart) {
          existingPart.premiumPrice = item.premiumPrice;
          existingPart.selectedQuantity = item.selectedQuantity;
        } else {
          const addInfo: AdditionalInfoInterface = {
            engineSize: item?.additionalCarInformation?.engineSize,
            grade: item?.additionalCarInformation?.grade,
            salesRegion: item?.additionalCarInformation?.salesRegion,
            transmissionType: item?.additionalCarInformation?.transmissionType,
            fuelType: item?.additionalCarInformation?.fuelType
          };
          this.cart.premiumQuotations.push({
            carId: item.carId,
            internalModelId: item.internalModelId._id || item.internalModelId,
            modelYear: item.modelYear,
            otherinformation: item.otherinformation,
            name: item.name,
            partType: item.partType,
            catalogueNumber: item.catalogueNumber,
            corePartId: item.corePartId,
            premiumPrice: item.premiumPrice,
            vinNumber: item.vinNumber,
            selectedQuantity: 1,
            addedFromPage: item.addedFromPage,
            photo: item.photo,
            additionalCarInformation: addInfo
          } as PremiumQuotationInterface);
          hasNew = true;
        }
        if (!item.carId) {
          delete item.carId;
        }
        if (item?.additionalCarInformation) {
          if (!item?.additionalCarInformation?.engineSize) {
            delete item.additionalCarInformation.engineSize;
          }
          if (!item?.additionalCarInformation?.grade) {
            delete item.additionalCarInformation.grade;
          }
          if (!item?.additionalCarInformation?.salesRegion) {
            delete item.additionalCarInformation.salesRegion;
          }
          if (!item?.additionalCarInformation?.transmissionType) {
            delete item.additionalCarInformation.transmissionType;
          }
          if (!item?.additionalCarInformation?.fuelType) {
            delete item.additionalCarInformation.fuelType;
          }
        }

      });
    }
    if (updatedCart.quotaParts?.length) {
      updatedCart.quotaParts.forEach((item) => {
        const existingPart = this.cart.quotaParts.find((part) => part._id === item._id);
        if (existingPart) {
          existingPart._id = item._id;
          existingPart.unitPrice = item.unitPrice;
          existingPart.selectedQuantity = item.selectedQuantity;
        } else {
          this.cart.quotaParts.push({
            _id: item._id,
            unitPrice: item.unitPrice,
            selectedQuantity: item.selectedQuantity
          });
          hasNew = true;
        }
      });
    }
    this.watchStorage.setItem('cart', JSON.stringify(this.cart));
    this.watchStorage.setItem('cartChange', true);
    return hasNew;
  }

  addPremiumQuotation(premiumQuotation: PremiumQuotationInterface, ClassV2: string = 'N/A') {
    const pass = this.validationPQ(premiumQuotation);
    if (!premiumQuotation.catalogueNumber) {
      return false;
    }
    if (!pass) {
      return false;
    }

    const matchingPart = this.getMatchingPartFromCart(premiumQuotation, this.cart.premiumQuotations, 'catalogueNumber');

    if (matchingPart) {
      matchingPart.selectedQuantity = matchingPart.selectedQuantity + 1;
    } else {
      this.cart.premiumQuotations.push(premiumQuotation);
    }
    rudderanalytics.track('Product Added', {
      product_id: premiumQuotation.carId,
      name: premiumQuotation.name,
      category: 'PremiumQuotation',
      quantity: premiumQuotation.selectedQuantity,
      price: premiumQuotation.premiumPrice,
      currency: 'SAR'
    });
    if (this.auth.isLoggedIn()) {
      this.doUpdateCart(this.cart);
      return true;
    }
    localStorage.setItem('cart', JSON.stringify(this.cart));
    this.watchStorage.setItem('cartChange', true);
  }

  getMatchingPartFromCart(part, cartList, key = '_id') {
    let matchingPart = null;
    try {
      matchingPart = cartList.find((item) => item[key] === part[key]);
    } catch (e) { }

    return matchingPart;
  }

  getMatchingStockPart(_id: string) {
    let matchingPart = null;
    try {
      matchingPart = this.cart.stockParts.find((item) => item._id === _id);
    } catch (e) { }
    return matchingPart;
  }

  removeStockPart(_id) {
    const index = this.cart.stockParts.findIndex((item) => item._id === _id);
    const stockPart: any = this.cart.stockParts[index];
    this.cart.stockParts.splice(index, 1);
    try {
      rudderanalytics.track('Product Removed', {
        product_id: stockPart._id,
        name: stockPart.name,
        category: 'StockParts',
        price: stockPart.unitPrice,
        quantity: stockPart.selectedQuantity
      });
    } catch (err) {
    }
    if (this.auth.isLoggedIn()) {
      this.doUpdateCart(this.cart);
      return true;
    }
    localStorage.setItem('cart', JSON.stringify(this.cart));
    this.watchStorage.setItem('cartChange', true);
    return true;
  }

  addStockPart(stockPart: StockPartInterface, ClassV2: string = 'N/A') {
    const pass = this.validationSP(stockPart);
    if (!pass) {
      return false;
    }
    const matchingPart = this.getMatchingPartFromCart(stockPart, this.cart.stockParts, '_id');
    if (matchingPart) {
      matchingPart.selectedQuantity = matchingPart.selectedQuantity + 1;
    } else {
      this.cart.stockParts.push(stockPart);
    }
    rudderanalytics.track('Product Added', {
      product_id: stockPart._id,
      name: stockPart.name,
      category: 'StockParts',
      quantity: stockPart.selectedQuantity,
      price: stockPart.unitPrice,
      currency: 'SAR'
    });
    if (this.auth.isLoggedIn()) {
      this.doUpdateCart(this.cart);
      return true;
    }
    localStorage.setItem('cart', JSON.stringify(this.cart));
    this.watchStorage.setItem('cartChange', true);
    return true;
  }

  getMatchingQuotation(catalogueNumber) {
    let matchingPart = null;
    try {
      matchingPart = this.cart.premiumQuotations.find((item) => item.catalogueNumber === catalogueNumber);
    } catch (e) { }
    return matchingPart;
  }

  removePremiumQuotation(index) {
    const premiumQuotation = this.cart.premiumQuotations[index];
    this.cart.premiumQuotations.splice(index, 1);
    if (!premiumQuotation) {
      return;
    }
    try {
      rudderanalytics.track('Product Removed', {
        product_id: premiumQuotation.carId,
        name: premiumQuotation.name,
        category: 'PremiumQuotation',
        price: premiumQuotation.premiumPrice,
        quantity: 1
      });
    } catch (err) {
    }
    if (this.auth.isLoggedIn()) {
      this.doUpdateCart(this.cart);
      return;
    }
    localStorage.setItem('cart', JSON.stringify(this.cart));
    this.watchStorage.setItem('cartChange', true);
    return;
  }

  updateStockPart(part) {
    let changed = false;
    this.cart.stockParts.map((item) => {
      if (item._id === part._id) {
        item.internalModelId = part.modelId;
        item.modelYear = part.modelYear;
        item.vinNumber = part.vinNumber;
        item.vinManuallyEntered = part.vinManuallyEntered;
        changed = true;
      }
      return item;
    });
    if (changed && this.auth.isLoggedIn()) {
      this.doUpdateCart(this.cart);
      return true;
    }
    localStorage.setItem('cart', JSON.stringify(this.cart));
    this.watchStorage.setItem('cartChange', true);
    return true;
  }

  doViewCart() {
    this.viewCart()
      .pipe(take(1))
      .subscribe((cartRes) => {
        let mergingCarts = false;
        if (cartRes.cart) {
          mergingCarts = this.doMapCart(cartRes.cart);
        }
        const body = JSON.parse(localStorage.getItem('cart'));
        if (mergingCarts) {
          // if local cart has at least one part matches
          // so we merge server cart and local cart then update server cart
          this.doUpdateCart({ ...body });
        } else {
          // if no parts matches that mean that server cart is empty
          // so we add local cart and update server cart
          this.doUpdateCart(body);
        }
      });
  }

  validationPQNotCatalog(obj) {
    let pass = true;
    const keys = [
      'carId',
      'internalModelId',
      'modelYear',
      'otherinformation',
      'partType',
      'selectedQuantity',
      'name',
      // optional but required for UI
      'premiumPrice',
      'vinNumber',
      '_id',
      'catalogueNumber',
      'corePartId',
      'unitPrice',
      'make',
      'manufactureId',
      'manufactureName',
      'modelName',
      'addedFromPage',
      'photo',
      'engineSize',
      'grade',
      'transmissionType',
      'fuelType',
      'salesRegion',
      'additionalCarInformation'
    ];

    Object.keys(obj).forEach((key) => {
      if (!keys.includes(key)) {
        pass = false;
      }
    });
    return pass;
  }

  validationQP(obj) {
    let pass = true;
    const keys = [
      '_id',
      'selectedQuantity',
      'catalogueNumber',
      'unitPrice',
      'name',
      'price',
      'partType',
      'make',
      'vinNumber',
      'manufactureId',
      'modelName',
      'modelYear',
      'manufactureName'
    ];
    Object.keys(obj).forEach((key) => {
      if (!keys.includes(key)) {
        pass = false;
      }
    });
    return pass;
  }

  validationPQ(obj) {
    let pass = true;
    const keys = [
      'carId',
      'internalModelId',
      'modelYear',
      'otherinformation',
      'partType',
      'corePartId',
      'selectedQuantity',
      'name',
      // optional but required for UI
      'catalogueNumber',
      'premiumPrice',
      'vinNumber',
      'manufactureName',
      'modelName',
      'addedFromPage',
      'engineSize',
      'grade',
      'transmissionType',
      'fuelType',
      'salesRegion',
      'additionalCarInformation'
    ];
    Object.keys(obj).forEach((key) => {
      if (!keys.includes(key)) {
        pass = false;
      }
    });
    return pass;
  }


  validationSP(obj) {
    let pass = true;
    const keys = [
      '_id',
      'name',
      'catalogueNumber',
      'selectedQuantity',
      'internalModelId',
      'modelYear',
      'externalCarId',
      'externalcatalogueId',
      // optionals but required for UI
      'unitPrice',
      'isPriceChanged',
      'availableQuantity',
      'branchName',
      'make',
      'isDomestic',
      'vinNumber',
      'manufactureName',
      'modelName',
      'addedFromPage',
      'partBrand'
    ];
    Object.keys(obj).forEach((key) => {
      if (!keys.includes(key)) {
        pass = false;
      }
    });
    return pass;
  }

}
export interface CartInterface {
  addressId?: string;
  quotaParts?: Array<QuotaPartInterface>;
  premiumQuotations?: Array<PremiumQuotationInterface>;
  usedParts?: Array<UsedPartInterface>;
  stockParts?: Array<StockPartInterface>;
  // to be removed from request
  deliveryFees?: any;
  discountAmount?: any;
  isDiscountCodeExpired?: boolean;
  isDiscountedDeliveryFees?: boolean;
  paidQuotationsAmount?: any;
  stockPartsAmount?: any;
  quotaPartsAmount?: number;
  partsTotalAmount?: number;
  vatAmount?: any;
  totalAmount?: any;
  totalAmountBeforeDiscount?: any;
  walletPaymentAmount?: any;
  updatedAt?: any;
}

export interface QuotaPartInterface {
  _id: string;
  selectedQuantity: number;
  catalogueNumber?: string;
  unitPrice?: number;
  name?: string;
  price?: number;
  partType?: string;
  make?: string;
  vinNumber?: string;
  manufactureId?: string;
  modelName?: string;
  modelYear?: string;
  manufactureName?: string;
}

export interface PremiumQuotationInterface {
  _id?: string;
  carId: string;
  internalModelId: string;
  modelYear: string;
  otherinformation: string;
  name: string;
  partType: string;
  catalogueNumber?: string;
  corePartId?: string;
  premiumPrice?: number;
  selectedQuantity: number;
  vinNumber?: string;
  manufactureName?: string;
  modelName?: string;
  unitPrice?: number;
  make?: number;
  manufactureId?: string;
  addedFromPage?: string;
  photo?: string[];
  additionalCarInformation?: AdditionalInfoInterface;
}
export interface AdditionalInfoInterface {
  engineSize?: string;
  grade?: string;
  transmissionType?: string;
  fuelType?: string;
  salesRegion?: string;
}

export interface UsedPartInterface {
  _id: string;
  selectedQuantity: number;
}

export interface StockPartInterface {
  _id: string;
  name: string;
  catalogueNumber?: string;
  unitPrice?: number;
  selectedQuantity: number;
  internalModelId: string;
  modelYear: string;
  externalCarId: string;
  externalcatalogueId: string;
  isPriceChanged?: boolean;
  isQuantityChanged?: boolean;
  availableQuantity?: number;
  branchName?: string;
  make?: string;
  isDomestic?: boolean;
  vinManuallyEntered?: boolean;
  vinNumber?: string;
  manufactureName?: string;
  modelName?: string;
  addedFromPage?: string;
  partBrand?: string;
}